export default "__VITE_ASSET__DG6Fas5___"